import type { ReactElement } from 'react';
import { useTranslation } from '@govard/i18n-core/react';
import { formatDate, formatDateTime, taskDueState } from '../../shared/format/entity-detail.js';
import { EntityStatusChip } from './EntityStatusChip.js';

export function EntityTaskDueChip({
  dueAt,
  closed = false,
  now = new Date(),
}: {
  dueAt?: string | null;
  closed?: boolean;
  now?: Date;
}): ReactElement | null {
  const { t } = useTranslation();
  const state = taskDueState(dueAt, now);
  if (state === 'none') return null;
  const days = Math.max(1, Math.floor((now.getTime() - new Date(dueAt!).getTime()) / 86_400_000));
  const label = closed
    ? formatDateTime(dueAt)
    : state === 'overdue'
      ? days > 30
        ? t('crm.entity_detail.overdue_since', { date: formatDate(dueAt) })
        : t('crm.entity_detail.overdue_days', { count: days })
      : formatDateTime(dueAt);
  return (
    <span>
      <EntityStatusChip
        tone={
          closed
            ? 'default'
            : state === 'overdue'
              ? 'error'
              : state === 'today'
                ? 'warning'
                : 'default'
        }
      >
        {label}
      </EntityStatusChip>
    </span>
  );
}
